import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import fortnoxAuth from '../services/fortnoxAuth';

function FortnoxCallback({ onConnected }) {
  const [status, setStatus] = useState('Processing...');
  const [error, setError] = useState(null);

  useEffect(() => {
    // Wait for user to be authenticated
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      
      if (!currentUser) {
        setStatus('Please log in first');
        setError('You must be logged in to connect Fortnox account.');
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
        return;
      }

      // User is authenticated, proceed with OAuth callback
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state'); // Hämta state från URL
      const errorParam = urlParams.get('error');

      console.log('Fortnox callback - code:', code ? 'present' : 'missing');
      console.log('Fortnox callback - state:', state ? 'present' : 'missing');
      console.log('Fortnox callback - error:', errorParam);
      console.log('Fortnox callback - user:', currentUser?.uid);

      // Validera state för att förhindra CSRF-attacker
      const savedState = sessionStorage.getItem('fortnox_oauth_state');
      if (!state || state !== savedState) {
        console.error('❌ State validation failed:', {
          received: state,
          expected: savedState,
        });
        setStatus('Security Error');
        setError('Sign-in could not be completed. Close this window and try connecting again from Integrations.');
        sessionStorage.removeItem('fortnox_oauth_state'); // Rensa
        setTimeout(() => {
          window.location.href = '/';
        }, 5000);
        return;
      }

      // Rensa state efter validering (förhindra replay-attacker)
      sessionStorage.removeItem('fortnox_oauth_state');
      console.log('✅ State validated successfully');

      if (errorParam) {
        const errorDesc = urlParams.get('error_description') || '';
        setStatus(`Error: ${errorParam}`);
        setError(errorDesc);
        setTimeout(() => {
          window.location.href = '/';
        }, 5000);
        return;
      }

      if (code) {
        console.log('Exchanging code for token...');
        fortnoxAuth.exchangeCodeForToken(code, state) // Skicka state till backend
          .then(async (tokens) => {
            console.log('Token received, saving to Firestore...');
            console.log('Tokens:', { 
              hasAccessToken: !!tokens.accessToken, 
              hasRefreshToken: !!tokens.refreshToken,
              expiresIn: tokens.expiresIn 
            });
            
            await fortnoxAuth.saveTokens(tokens);
            console.log('Tokens saved successfully!');
            
            setStatus('Success! Fortnox account connected. Redirecting...');
            if (onConnected) {
              onConnected();
            }
            setTimeout(() => {
              window.location.href = '/';
            }, 2000);
          })
          .catch((err) => {
            console.error('Error in callback:', err);
            setStatus(`Error: ${err.message}`);
            setError(err.message);
            setTimeout(() => {
              window.location.href = '/';
            }, 5000);
          });
      } else {
        setStatus('No authorization code received');
        setError('The authorization code is missing from the URL.');
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
      }
    });

    return () => unsubscribe();
  }, [onConnected]);

  return (
    <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Fortnox Authorization</h2>
      <p style={{ fontSize: '18px', marginTop: '20px' }}>{status}</p>
      {error && (
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fee', border: '1px solid #fcc', borderRadius: '5px' }}>
          <strong>Details:</strong> {error}
        </div>
      )}
      <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        You will be redirected automatically...
      </p>
    </div>
  );
}

export default FortnoxCallback;